import {
  IsArray,
  IsEnum,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { Gender, ResidentState } from '@pflegenavi/shared/api';
export class ServiceProviderAppResidentDto {
  @IsNotEmpty()
  @IsString()
  @IsUUID(4)
  id!: string;
  @IsNotEmpty()
  @IsString()
  firstName!: string;
  @IsNotEmpty()
  @IsString()
  lastName!: string;
  @IsNotEmpty()
  @IsString()
  gender!: Gender;
}

class GetResidentListQueryDto {
  /** Tenant mostly exist for the client */
  @IsNotEmpty()
  @IsUUID(4)
  tenant!: string;
  @IsNotEmpty()
  @IsUUID(4)
  nursingHomeId!: string;
  @IsOptional()
  @IsArray()
  @IsEnum(ResidentState, { each: true })
  residentStates?: ResidentState[];
  @IsOptional()
  @IsArray()
  @IsUUID(4, { each: true })
  residentIds?: string[];
}

export const ServiceProviderAppControllerDefinition = {
  controller: 'service-provider-app',
  endpoints: {
    getResidentList: {
      method: 'GET',
      url: 'residents',
      response: undefined as unknown as ServiceProviderAppResidentDto[],
      body: undefined,
      query: undefined as unknown as GetResidentListQueryDto,
    },
  },
} as const;

export type ServiceProviderAppControllerResultTypes = {
  [key in keyof (typeof ServiceProviderAppControllerDefinition)['endpoints']]: (typeof ServiceProviderAppControllerDefinition)['endpoints'][key]['response'];
};
export type ServiceProviderAppControllerQueryTypes = {
  [key in keyof (typeof ServiceProviderAppControllerDefinition)['endpoints']]: (typeof ServiceProviderAppControllerDefinition)['endpoints'][key]['query'];
};
export type ServiceProviderAppControllerBodyTypes = {
  [key in keyof (typeof ServiceProviderAppControllerDefinition)['endpoints']]: (typeof ServiceProviderAppControllerDefinition)['endpoints'][key]['body'];
};
